// extracted by mini-css-extract-plugin
export default {"violetButton":"user-by-id_violetButton__6qgvj","buttonContainer":"user-by-id_buttonContainer__XgG6H"};